import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
//import { AuthService } from 'src/app/services/auth.service';
import * as CryptoJS from 'crypto-js';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-login-with-password',
  templateUrl: './login-with-password.component.html',
  styleUrls: ['./login-with-password.component.scss']
})
export class LoginWithPasswordComponent implements OnInit {
  url: any;
  passwordMode: string = "password";
  passwordButtons1: { icon: string; stylingMode: string; onClick: () => void; };
  passwordButtons2: { icon: string; stylingMode: string; onClick: () => void; };
  showIcon : boolean = true;

  constructor(private toasterService: ToasterService, private router: Router, private loginService: LoginService
  ) { 
    this.passwordButtons1 = {
      icon: 'fa fa-eye',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
        this.showIcon = !this.showIcon;
      },
    };

    this.passwordButtons2 = { 
      icon: 'fa fa-eye-slash',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
        this.showIcon = !this.showIcon;
      },
    };
  }


  userPassword: any = '';
  //confPassword: any;


  ngOnInit() {
  }

  //passwordComparison = () => this.userPassword;

  encryptField(entity) {
    var key = CryptoJS.enc.Base64.parse('2b7e151628aed2a6abf7158809cf4f3c'); //new key
    var iv = CryptoJS.enc.Base64.parse('S4duQOLzqeKP3rf8nSb5Ow==');          //new iv

    var encrypted = CryptoJS.AES.encrypt(entity, key, { iv: iv });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  login(e) {
    console.log("e")
    let result = e.validationGroup.validate();
    if (result.isValid) {
      let password = this.encryptField(this.userPassword);
      this.loginService.loginWithPassword(password).subscribe(result => {
        console.log(result)
        if (result["message"].code == 200) {
          if (result["data"] != null) {
            this.url = result["data"].data.url;
            //console.log(this.url);
            localStorage.clear();
            window.location.href = this.url;
          } else {
            this.toasterService.pop("error", result["message"].message);
          }
        }else if(result["message"].code == 1513){
          this.toasterService.pop("error", "Login Id is invalid!")
        }else if(result["message"].code == 7004){
          this.toasterService.pop("error", "Invalid Password!")
        }else if(result["message"].code == 888){
          this.toasterService.pop('error', "Please login after some time!!");
          this.router.navigate(['fynd-login'])
        }else {
          this.toasterService.pop("error", result["message"].message);
          this.router.navigate(['fynd-login']);
        }

      })
    } else {
      this.toasterService.pop("error", "Invalid Password!")
    }
  }

}
